import { call } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';
import * as Api from '../../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../../helpers/saga';
import {
  fetchROItems as fetchROItemsRoutine,
  fetchROItemForEdit as fetchROItemForEditRoutine,
  fetchROItemForView as fetchROItemForViewRoutine,
  createROItem as createROItemRoutine,
  updateROItem as updateROItemRoutine,
  deleteROItem as deleteROItemRoutine,
  fetchROItemAssocPicklistCount as fetchROItemAssocPicklistCountRoutine
} from './routines';
import { reservationsROItemViewPath } from '../../../../routes/Paths';
import history from '../../../../routes/history';
import pagePathToUrl from '../../../../helpers/pagePathToUrl';

export const fetchROItems = ({ payload: qs }) =>
  sagaRoutineRequest(fetchROItemsRoutine, {
    request: () => call(Api.fetchROItems, { qs })
  });

export const fetchROItemForEdit = ({ payload: id }) =>
  sagaRoutineRequest(fetchROItemForEditRoutine, {
    request: () => call(Api.fetchROItem, id)
  });

export const fetchROItemForView = ({ payload: id }) =>
  sagaRoutineRequest(fetchROItemForViewRoutine, {
    request: () => call(Api.fetchROItem, id)
  });

export const fetchROItemAssocPicklistCount = ({ payload: id }) =>
  sagaRoutineRequest(fetchROItemAssocPicklistCountRoutine, {
    request: () => call(Api.fetchROItemAssocPicklistCount, id)
  });

export const createROItem = ({ payload: { body } }) =>
  sagaRoutineRequest(createROItemRoutine, {
    request: () => call(Api.createROItem, { body }),
    *success({ id }) {
      yield toastr.success('Success', 'Item successfully created.');
      history.push(pagePathToUrl(reservationsROItemViewPath, { id }));
    }
  });

export const updateROItem = ({ payload: { id, body } }) =>
  sagaRoutineRequest(updateROItemRoutine, {
    request: () => call(Api.updateROItem, { id, body }),
    *success() {
      yield toastr.success('Success', 'Item successfully updated.');
      history.push(pagePathToUrl(reservationsROItemViewPath, { id }));
    }
  });

export const deleteROItem = ({ payload: { name, id } }) =>
  sagaRoutineRequest(deleteROItemRoutine, {
    request: () => call(Api.deleteROItem, id),
    successPayload: { id },
    *success() {
      yield toastr.success('Success', `Deleted Item "${name}".`);
    }
  });
